const STORAGE_KEY = 'embedded-sidebar-open'

export function readSidebarOpenFromStorage(): boolean {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === null) return false
    return stored === 'true'
  } catch {
    return false
  }
}

export function writeSidebarOpenToStorage(open: boolean) {
  try {
    localStorage.setItem(STORAGE_KEY, String(open))
  } catch {
    // localStorage unavailable
  }
}
